import { defineComponent } from 'vue';
import DCApp from "./../Shared/App.vue";
import * as bootstrap from "bootstrap";
import * as Vue from 'vue';
import axios, { AxiosResponse } from 'axios';
import { createPinia } from 'pinia';

let greturnurl: string;
greturnurl = "";

export class DCResetPasswordRequest {
    public confirmationtoken: string = "";
    public password: string = "";
    public passwordverif: string = "";
    public userid: number = 0;
}

const mixin = defineComponent({
    data() {
        return {
            returnurl: "",
            status:"",
        };
    },

     mounted() {
        this.returnurl = greturnurl;
        $("#returnurlmodal").val(this.returnurl);
        this.DCLoginOpenLoginModal();
    },
    methods: {
        DCLoginOpenLoginModal() {

            let elt = document.getElementById('dc_logindialog');
            if (elt !== null) {
                let modal = new bootstrap.Modal(elt, {});
                modal.show();
            }
        }
    }

});


export class LoginComponent {

    public Init(returnurl: string) {
        greturnurl = returnurl;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).LoginComponent = function () { return new LoginComponent(); };